import { useNavigate } from "react-router-dom";
import { getImageUrl } from "../../../lib/get-image";
import styles from "./collection-item.module.css";

const CollectionItem = ({ category }) => {
  const navigate = useNavigate();
  const { name, slug, cat_image } = category;

  return (
    <div
      className={styles.collection__item}
      onClick={() => navigate(`/shop/${slug}`)}
    >
      <div className={styles.card}>
        <img
          src={getImageUrl(cat_image)}
          alt={name}
          className={styles.collection__image}
        />
      </div>

      <p className={styles.subTitle}>{name}</p>
    </div>
  );
};

export default CollectionItem;